import Axios from "axios";

const base_url = "cp/branches";

export default {
    /**
     * Display a listing of the branches.
     *
     * @param {int} page number of page for pagination
     * @param {object} params filter (search) options
     * @returns {Promise}
     */
    getAll(page = 1, params = {}) {
        return Axios.get(base_url + "?page=" + page, { params });
    },

    /**
     * Get all branches with specific properties of branches.
     *
     * @returns {Promise}
     */
    getAllShort() {
        return Axios.get(`${base_url}/short`);
    },

    /**
     * Store a new Branch in server.
     *
     * @param {object} data item properties
     * @returns {Promise}
     */
    create(data) {
        return Axios.post(base_url, data);
    },

    /**
     * Update the given Branch in server.
     *
     * @param {object} data item properties
     * @returns {Promise}
     */
    update(data) {
        return Axios.put(base_url + "/" + data.id, data);
    }
};
